import { api } from '@api/client'

export const assetService = {
  async fetchAsset (companyId, siteId, assetId) {
    const response = await api.get(
      `/company/${companyId}/sites/${siteId}/assets/${assetId}`
    )
    return response
  }
}

// export const assetService = {
//   async fetchAsset(companyId, siteId, assetId) {
//     const response = await api.get('/companies/windfarms/assets/info',
//       {
//         params: {
//           CompanyID: companyId,
//           WindFarmID: siteId,
//           WTID: assetId,
//         },
//       }
//     );

//     return response;
//   }
// }
